var React = require( 'react' );
var createReactClass = require('create-react-class');
var PureRenderMixin = require('react-addons-pure-render-mixin');

var ContentHeader = createReactClass({
    mixins: [PureRenderMixin],

	render: function(){
		return (
            <div className="content-header-wrapper">
                <div className="content-header-small content-header row column">
                    <h1>Gi Treatment Center</h1>
                </div>
            </div>
        );
	}
});

module.exports = ContentHeader;



// WEBPACK FOOTER //
// ./src/common/routes/conditions/components/layout/contentHeader.jsx